export type SelfTrainingModel = typeof selfTrainingModel;

const selfTrainingModel = {
  selfTrainingSelection: {
    Sprechen: false,
    Verstehen: false,
    Lesen: false,
    Schreiben: false,
  },
};

export default selfTrainingModel;
